export const RoleName = {
    ADMIN: "Admin",
    BACK_OFFICE: "BackOffice",
    TECNICO_DE_CAMPO: "TecnicoDeCampo",
    GESTOR_DE_EQUIPE: "GestorDeEquipe",
    GESTOR_DE_CENTRO_DE_SERVICO: "GestorDeCentroDeServico",
    ADMINISTRADOR_DE_CONTRATO: "AdministradorDeContrato",
    ANALISTA_CTMO: "AnalistaCTMO"
};
